import { cookiesAsEntries } from '@doordash/network'
import * as queryString from 'query-string'

function ifUrlParam(param, location, f) {
  const params = queryString.parse(location.search)
  if (params[param]) {
    return f(params[param])
  }
  return undefined
}

function generateDataObject(entries) {
  return entries.reduce((obj, [field, value]) => {
    return value != null ? { ...obj, [field]: value } : obj
  }, {})
}

/**
 * Retrieve all the DoorDash Common Fields from the browser cookies
 * and return them as an object.
 *
 * These are created by the backend and set as cookies starting with 'dd_'.
 *
 * @returns {object} key-value representation of all current common fields
 */
export function cookieData(raw) {
  const entries = cookiesAsEntries(raw).filter(([key]) =>
    key.toLowerCase().startsWith('dd_')
  )
  return generateDataObject(entries)
}

/**
 * Returns an object containing the common session data that should be
 * attached to the event payload for each tracking event.
 */
export function clientData({
  hasTouchEvents,
  isMobile,
  innerWidth,
  innerHeight,
  location,
  document,
  navigator,
  sha,
  currentLanguage,
}) {
  const entries = [
    ['referrer', document.referrer],
    ['platform', isMobile ? 'mobile' : 'desktop'],
    ['browser_width', innerWidth],
    ['browser_height', innerHeight],
    ['touch', hasTouchEvents],
    ['href', location.href],
    ['user_agent', navigator.userAgent],
    ['rendered_by', sha],
    ['language', currentLanguage],
    [
      'utmCampaign',
      ifUrlParam('utm_campaign', location, value => decodeURIComponent(value)),
    ],
    [
      'utmSource',
      ifUrlParam('utm_source', location, value => decodeURIComponent(value)),
    ],
    [
      'utmMedium',
      ifUrlParam('utm_medium', location, value => decodeURIComponent(value)),
    ],
  ]
  return generateDataObject(entries)
}
